import { render } from "./ModalValidations.vue?vue&type=template&id=fb473f20&scoped=true"
import script from "./ModalValidations.vue?vue&type=script&lang=js"
export * from "./ModalValidations.vue?vue&type=script&lang=js"

import "./ModalValidations.vue?vue&type=style&index=0&id=fb473f20&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb473f20"],['__file',"src/js/vue/components/ModalValidations.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "fb473f20"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('fb473f20', __exports__)) {
    api.reload('fb473f20', __exports__)
  }
  
  module.hot.accept("./ModalValidations.vue?vue&type=template&id=fb473f20&scoped=true", () => {
    api.rerender('fb473f20', render)
  })

}


export default __exports__